import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ASQPowerBIReport from '../../../../common/components/molecules/ASQPowerBIReport';
import { expirationTokenInterval, useCommercialReportsQuery } from '../../../../common/hooks/backend';
import { getReportChangeListenerForFiltersAndSlicers } from '../../../../common/utils/power-bi-filters';
import { Module } from '../../../../core/enums/module.enum';
import { withFeatureFlag } from '../../../../core/featureFlags/FeatureFlag';
import { FeatureFlagKey } from '../../../../core/featureFlags/featureFlagKeys';
import { useSetCurrentPowerBiFilters } from '../../../../core/powerBi/hooks';
import DashboardHeader from '../../dashboards/components/molecules/DashboardHeader';
import {
  getCommercialInfoMessageTranslateKey,
  getCommercialTitleTranslateKey,
  useCommercialDashboard,
} from '../dashboards';

function Dashboards(): ReactElement {
  const { t } = useTranslation('Commercial');

  const {
    dashboard,
    pageName,
    onPageChange,
    onSlicerChange,
    onButtonClick,
    synchronizeAirportCodeAndSubscriptionAndPeriod,
  } = useCommercialDashboard(Module.Commercial);

  const { data: embedRequest, isLoading } = useCommercialReportsQuery(undefined, {
    pollingInterval: expirationTokenInterval,
  });

  const infoMessageTranslateKey = getCommercialInfoMessageTranslateKey(dashboard);

  const [, setCurrentPowerBiFilters] = useSetCurrentPowerBiFilters();
  const onRendered = getReportChangeListenerForFiltersAndSlicers(setCurrentPowerBiFilters);

  return (
    <>
      {dashboard !== null && (
        <DashboardHeader
          title={t(getCommercialTitleTranslateKey(dashboard))}
          infoMessage={infoMessageTranslateKey !== null ? t(infoMessageTranslateKey) : undefined}
        />
      )}
      <ASQPowerBIReport
        embedRequest={embedRequest}
        isLoading={isLoading}
        pageName={pageName ?? undefined}
        onPageChange={onPageChange}
        onLoaded={synchronizeAirportCodeAndSubscriptionAndPeriod}
        onSlicerChange={onSlicerChange}
        onButtonClick={onButtonClick}
        onRendered={onRendered}
        showFilters
      />
    </>
  );
}

const DashboardsFeature = withFeatureFlag(Dashboards, FeatureFlagKey.CommercialReports);

export default DashboardsFeature;
